import clsx from 'clsx';
import type { ReactElement } from 'react';

export type InstructionItemProps = {
  item: string;
  title: string;
  description: React.ReactNode;
  showDot: boolean;
  dotHeight?: string;
};

function InstructionItem({
  item,
  title,
  description,
  showDot,
  dotHeight = 'medium',
}: InstructionItemProps): ReactElement {
  return (
    <div className="instruction-item-container">
      <p
        className={clsx('instruction-item-container__circle', {
          'instruction-item-container__dot-small':
            dotHeight === 'small' && showDot,
          'instruction-item-container__dot-medium':
            dotHeight === 'medium' && showDot,
          'instruction-item-container__dot-large':
            dotHeight === 'large' && showDot,
        })}
      >
        {item}
      </p>
      <div className="instruction-item-container__content">
        <p className="instruction-item-container__content--title">{title}</p>
        <p className="instruction-item-container__content--description">
          {description}
        </p>
      </div>
    </div>
  );
}

export default InstructionItem;
